package com.vamvisions.main.core.domain

sealed interface DataError : Error {

    /**
     * A failed call to the server API. [code] is the stable `ApiError.code` from the response body,
     * when the server sent one.
     */
    data class Network(val type: Type, val code: String? = null) : DataError {
        enum class Type {
            NO_CONNECTION,
            NOT_FOUND,
            BAD_REQUEST,
            TOO_MANY_REQUESTS,
            SERVER,
            SERIALIZATION,
            UNKNOWN,
        }
    }
}
